<ion-item lines="none" class="ion-no-padding" [title]="lockIndicator == true ? lockTitle : ''">
  <ion-label *ngIf="!hideLabel" position="stacked" [class.disabled]="disabled">
    <ion-icon *ngIf="lockIndicator" slot="start" [name]="(disabled) ? 'lock-closed-outline' : 'lock-open-outline'"
      class="no-pointer-evts"></ion-icon>
    {{ label + (required ? '*' : '') }}
  </ion-label>
  <div class="datetime-container flex" [id]="id">
    <!-- Date Picker Button -->
    <div class="datetime-item" *ngIf="type === 'datetime' || type === 'date'">
      <ion-datetime-button [disabled]="disabled" #dateButton [datetime]="dateInputId">
        <span slot="date-target" *ngIf="inputDate == null">dd mm, yyyy</span>
      </ion-datetime-button>
      <ion-icon name="calendar-outline" class="input-icon"></ion-icon>
    </div>

    <!-- Time Picker Button -->
    <div class="datetime-item" *ngIf="type === 'datetime' || type === 'time'">
      <ion-datetime-button [disabled]="disabled" #timeButton [datetime]="timeInputId">
        <span slot="time-target" *ngIf="inputTime == null">--:-- --</span>
      </ion-datetime-button>
      <ion-icon name="time-outline" class="input-icon"></ion-icon>
    </div>
  </div>
</ion-item>

<p *ngIf="subLabel != null" class="sub-label">
  {{ subLabel }}
</p>

<!-- Date Picker Modal -->
<ion-modal keepContentsMounted="true">
  <ng-template>
    <ion-datetime
      #datePicker
      [id]="dateInputId"
      presentation="date"
      [(ngModel)]="inputDate"
      [max]="maxDate"
      [min]="minDate"
      (ngModelChange)="inputChange()"
    >
      <ion-buttons slot="buttons">
        <ion-button color="danger" (click)="datePicker.reset()">Clear</ion-button>
        <ion-button color="primary" (click)="datePicker.confirm(true)">Done</ion-button>
      </ion-buttons>
    </ion-datetime>
  </ng-template>
</ion-modal>

<!-- Time Picker Modal -->
<ion-modal keepContentsMounted="true">
  <ng-template>
    <ion-datetime
      #timePicker
      [id]="timeInputId"
      presentation="time"
      [attr.minute-values]="minuteOptions ? minuteOptions : null"
      [(ngModel)]="inputTime"
      (ngModelChange)="inputChange()"
    >
      <ion-buttons slot="buttons">
        <ion-button color="danger" (click)="timePicker.reset()">Clear</ion-button>
        <ion-button color="primary" (click)="timePicker.confirm(true)">Done</ion-button>
      </ion-buttons>
    </ion-datetime>
  </ng-template>
</ion-modal>

<!-- <p>
  Date: {{ inputDate }}<br/>
  Time: {{ inputTime }}<br/>
  Value: {{ value }}
</p> -->